import { Controller } from '@hotwired/stimulus';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['overlay'];

  connect() {
    document.addEventListener('loading-indicator:show', this.show.bind(this));
    document.addEventListener('loading-indicator:hide', this.hide.bind(this));
  }

  show() {
    showElement(this.overlayTarget);
  }

  hide() {
    hideElement(this.overlayTarget);
  }
}

export function show() {
  document.body.dispatchEvent(
    new CustomEvent('loading-indicator:show', {
      bubbles: true,
    })
  );
}

export function hide() {
  document.body.dispatchEvent(
    new CustomEvent('loading-indicator:hide', {
      bubbles: true,
    })
  );
}
